import React, { useState, useEffect } from 'react'
import { adminApi } from '../utils/api'

export default function MaintenanceBanner() {
  const [maintenance, setMaintenance] = useState({ maintenanceMode: false, message: '' })

  useEffect(() => {
    const checkMaintenance = async () => {
      try {
        const response = await adminApi.getMaintenance()
        setMaintenance(response.data.data)
      } catch (err) {
        console.error('Failed to check maintenance status:', err)
      }
    }

    checkMaintenance()
    // Check every 30 seconds
    const interval = setInterval(checkMaintenance, 30000)
    return () => clearInterval(interval)
  }, [])

  if (!maintenance.maintenanceMode) return null

  return (
    <>
      <div className="maintenance-banner top">
        <span className="maintenance-text">
          ⚠️ {maintenance.message || 'System Under Maintenance'} ⚠️
        </span>
      </div>
      <div className="maintenance-banner bottom">
        <span className="maintenance-text">
          ⚠️ {maintenance.message || 'System Under Maintenance'} ⚠️
        </span>
      </div>
      <style>{`
        .maintenance-banner {
          position: fixed;
          left: 0;
          right: 0;
          z-index: 9999;
          background: #dc2626;
          color: white;
          text-align: center;
          padding: 8px 16px;
          font-weight: 600;
        }

        .maintenance-banner.top {
          top: 0;
        }

        .maintenance-banner.bottom {
          bottom: 0;
        }

        .maintenance-text {
          animation: flash 1s ease-in-out infinite;
        }

        @keyframes flash {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }

        /* Add padding to body to account for banner */
        body {
          padding-top: 40px;
          padding-bottom: 40px;
        }
      `}</style>
    </>
  )
}